import { ItemDatasetEnum } from "../constants";
import { ItemType } from "../types";

interface Props {
  item: HTMLAnchorElement;
  index: number;
}

const getItemData = ({ item, index }: Props): ItemType => {
  if (!item) return null;

  const { dataset, href } = item;

  const isVideo = dataset?.[ItemDatasetEnum.IS_VIDEO] !== undefined;

  return {
    description: dataset?.[ItemDatasetEnum.DESCRIPTION],
    sizes: dataset?.[ItemDatasetEnum.SIZES],
    src: isVideo ? dataset?.[ItemDatasetEnum.SRC] : href,
    srcset: dataset?.[ItemDatasetEnum.SRCSET],
    type: isVideo ? "video" : "img",
    poster: dataset?.[ItemDatasetEnum.POSTER],
    slidePositionIndex: index,
  };
};

export default getItemData;
